import { Controller } from "@hotwired/stimulus";

import { Tab } from "bootstrap";

export default class TabsController extends Controller {
  static values = {
    index: { type: Number, default: 0 },
  };

  static targets = ["tab"];

  connect() {
    this.dispatch("tabChanged", {
      detail: {
        currentIndex: this.indexValue,
        totalTabs: this.tabTargets.length,
      },
    });
  }

  toggleTab() {
    const el = this.tabTargets[this.indexValue];

    // カレントのタブボタンが画面内に収まるようタブメニュー内をスクロール
    el.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });

    Tab.getOrCreateInstance(el).show();

    window.scrollTo({ top: 0, behavior: 'smooth' });

    const url = new URL(location.pathname, location.origin);

    url.searchParams.set("tab", this.indexValue);
    history.pushState({}, "", url);

    this.dispatch("tabChanged", {
      detail: {
        currentIndex: this.indexValue,
        totalTabs: this.tabTargets.length,
      },
    });
  }

  showNextTab() {
    if (this.indexValue === this.tabTargets.length - 1) return;

    this.indexValue = this.indexValue + 1;

    this.toggleTab();
  }

  showBackTab() {
    if (this.indexValue === 0) return;

    this.indexValue = this.indexValue - 1;

    this.toggleTab();
  }

  setIndex(e) {
    this.indexValue = e.params.index;

    this.toggleTab();
  }

  emphasizeTab(e) {
    const el = this.tabTargets[e.detail.tabIndex];

    el.classList.add("bg-kuled-light");
  }

  deemphasizeTab(e) {
    const el = this.tabTargets[e.detail.tabIndex];

    el.classList.remove("bg-kuled-light");
  }
}
